import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-appbg">
        <div className="text-slate font-ui text-sm" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
